import request from '@/utils/request'; // 获取审核列表

export function fetchList(data) {
  return request({
    url: '/pmsservice/api/pcLinkSysUser/list',
    method: 'post',
    data: data
  });
} // 审核

export function fetchUpdate(data) {
  return request({
    url: '/pmsservice/api/pcLinkSysUser/update',
    method: 'post',
    data: data
  });
} // 删除

export function fetchDelete(data) {
  return request({
    url: '/pmsservice/api/pcLinkSysUser/delete',
    method: 'post',
    data: data
  });
}